import { RoleName } from "@/config";

export enum ProductSearchFilterTypeId {
    List = 1,
    Dropdown = 2,
}

export enum BusinessUnitFilterName {
    Magnesia = "Magnesia",
    PersonalCare = "PersonalCare",
    CoatingSolutions = "CoatingSolutions"
}

export const BUSINESS_UNIT_FILTER_MAPPING: Record<string, BusinessUnitFilterName> = {
    [RoleName.Magnesia]: BusinessUnitFilterName.Magnesia,
    [RoleName.PersonalCare]: BusinessUnitFilterName.PersonalCare,
    [RoleName.CoatingSolutions]: BusinessUnitFilterName.CoatingSolutions
};

export enum SortOptionName {
    Descending = "desc",
    Ascending = "asc",
}